export const activityConf = {
    yun_bi_ji: {
        startTime: 1668355200000,
        endTime: 1669564799000,
    },
};
